import FormData from "csi/action/FormData";
import { View } from "csi/def/View";
import reflection from "csi/reflection";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";
import WizardContent from "csi/wizard/Content";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";
import _ from "underscore";
import SiteViewCopyShapeController from "./SiteViewCopyShapeController";

const CopyShape = declare([SiteViewCopyShapeController, ActionControllerMixin], {

	fdShapeFormPage: null,
	fdSizeChartsPage: null,
	fdDocumentsPage: null,
	fdReferencedDocumentsPage: null,
	fdImagesPage: null,
	SHAPE_MASTER_NAME: "ShapeMasterName",
	SHAPE_SIZE_RANGE: "ShapeSizeRange",
	SHAPE_SEASONS: "ShapeSeasons",
	IMAGE_SELECT_PAGE_INDEX: 3,

	/** 
	 * @override
	 * Set isPromoteAction to the viewParams for ShapeForm on copy and New Shape From current shape
	 */
	onWizardViewPreCreate: function(wizard, page: WizardContent, defView: View, viewParams: any) {
		const index = wizard.getIndexOfPage(page);
		if (index === 0) {
			viewParams.isCopyShapeAction = true;
		} else if (index == this.IMAGE_SELECT_PAGE_INDEX) { // Needed to see the thumbnail images on the ImageSelect table view
			viewParams["imageSize"] = reflection.IMAGE_SIZE_SMALLEST;
		}
		if (index !== 0) {
			// Pre-select all the elements by defaults
			viewParams.onViewResults = function(qr, resultNodes): void { 
				_.each(resultNodes, (node) => {
					wizard.getFormDataFromPage(page)
						.changeSelection(wizard.getContext(node.$URL), true);
				});
			};
		}
	},

	/**
	*@override
	* Prepare the data and pass it into the next page
	*/
	onNextPage(wizard, currentPage, nextPage, bFinish) {
		let fd: FormData = this.m_formData;
		const indexOfPage = wizard.getIndexOfPage(nextPage);
		if (indexOfPage == 0) {
			fd = this.fdShapeFormPage = this.m_formData;
		} else if (indexOfPage == 1) {
			fd = this.fdSizeChartsPage = this.fdSizeChartsPage || new FormData(this);
		} else if (indexOfPage == 2) {
			fd = this.fdDocumentsPage = this.fdDocumentsPage || new FormData(this);
		} else if (indexOfPage == 3) {
			fd = this.fdReferencedDocumentsPage = this.fdReferencedDocumentsPage || new FormData(this);
		} else if (indexOfPage == 4) {
			fd = this.fdImagesPage = this.fdImagesPage || new FormData(this);
		}
		return (fd && !bFinish) ? wizard.setFormDataToPage(nextPage, fd, (wizard.getIndexOfPage(nextPage) == 1)): null;
	},

	/**
	 * @override
	 * Set the parameters to the call method
	 */
	toWriter: function () {
		const { fdShapeFormPage, SHAPE_SEASONS } = this;
		const shapeName = fdShapeFormPage.getFieldValue(xml.ATTR_NAME);
		const seasons = fdShapeFormPage.getFieldValue(SHAPE_SEASONS);
		
		const { m_urlNode, fdSizeChartsPage, fdDocumentsPage, fdReferencedDocumentsPage, fdImagesPage } = this;
		const call = this.inherited<CallMethod>(arguments);
		
		call.addParameter("URL", xml.ATTR_CNL, m_urlNode);
		call.addParameter("ShapeName", xml.ATTR_STRING, shapeName);
		call.addParameter("Seasons", xml.ATTR_REFLIST, seasons);
		call.addParameter("SizeCharts", xml.ATTR_REFLIST, fdSizeChartsPage ? fdSizeChartsPage.getSelectedValue() : []);
		call.addParameter("Documents", xml.ATTR_REFLIST, fdDocumentsPage ? fdDocumentsPage.getSelectedValue() : []);
		call.addParameter("ReferencedDocuments", xml.ATTR_REFLIST, fdReferencedDocumentsPage ? fdReferencedDocumentsPage.getSelectedValue() : []);
		call.addParameter("Images", xml.ATTR_REFLIST, fdImagesPage? fdImagesPage.getSelectedValue(): []);

		return call;
	},

});

export = CopyShape;
